import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../enum/enum";
import { useLoader } from "../../context/loaderContext";
import { useAuth } from "../../context/authContext";
import Layout from "../../layout/layout";
import moment from "moment";


const TargetWise = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();




    const [targetWiseReport, setTargetWiseReport] = useState([]);

    const [inputSlotId, setInputSlotId] = useState(() => {
        const storedSlotId = localStorage.getItem("slotId");
        return storedSlotId ? parseInt(storedSlotId, 10) : 0;
    });

    useEffect(() => {
        const storedSlot = localStorage.getItem("slotId");
        if (storedSlot) getData(storedSlot);
    }, []);

    const handleSearch = () => {
        if (!inputSlotId) {
            alert("Please enter a Slot ID");
            return;
        }

        localStorage.setItem("slotId", inputSlotId);

        getData(inputSlotId);
    };

    const getData = async () => {
        try {
            const url = `${BaseUrl}dashboard/LevelTargetReport`;


            const obj = {
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "uid": 0,
                    "userID": userId,
                    "version": Version

                },
                "request": {
                    "strUserId": userId,
                    "CommonInt": inputSlotId
                }
            }

            // const obj = {
            //     "appSession": {
            //         "appid": Appid,
            //         "imei": Imei,
            //         "loginTypeID": LoginTypeID,
            //         "regKey": "",
            //         "serialNo": SerialNo,
            //         // "session": token,
            //         "session": "1c272a1b8d0e6aeee6a1efaf1eef2e43",
            //         // "sessionID": sessionId,

            //         "sessionID": 602399,
            //         "uid": 0,
            //         "userID": 10765,
            //         //  "userID": userId,
            //         "version": Version

            //     },
            //     "request": {
            //         // "strUserId": userId,
            //         "strUserId": 10765,
            //         CommonInt: inputSlotId
            //     }
            // }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setTargetWiseReport(res.data.data || []);
            } else {
                setTargetWiseReport([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid income-report-main">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> Unit Target Report </h5>
                                    </div>

                                    <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '16px'
                                        }}
                                    >

                                        <div>
                                            <label className="form-label">Slot ID</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter Slot ID..."
                                                value={inputSlotId}
                                                onChange={(e) => setInputSlotId(parseInt(e.target.value, 10) || 0)}

                                            />
                                        </div>

                                        <div className="d-flex-end">
                                            <button
                                                type="button"

                                                onClick={handleSearch}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div>

                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            targetWiseReport?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Slot Id</th>
                                                                <th scope="col"> UserId</th>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Old Unit</th>
                                                                <th scope="col">Required Unit</th>
                                                                <th scope="col">Completed Unit</th>
                                                                <th scope="col">Entry Date</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                targetWiseReport?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{el.slotID}</td>
                                                                        <td>{el.userID}</td>
                                                                        <td>{el.name}</td>
                                                                        <td>{el.oldProduct}</td>
                                                                        <td>{el.requiredProduct}</td>
                                                                        <td>{el.completedProduct}</td>
                                                                        <td>{el.entryDate}</td>

                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only mt-3">
                                        {targetWiseReport?.length > 0 ? (
                                            targetWiseReport.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        <span className="small">{el.entryDate}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Slot Id:</strong>
                                                        <p className="mb-0 f-w-500">{el.slotID}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>userID:</strong>
                                                        <p className="mb-0 f-w-500">{el.userID}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Name:</strong>
                                                        <p className="mb-0 f-w-500">{el.name}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Old Unit :</strong>
                                                        <p className="mb-0 f-w-500">{el.oldProduct}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Required Unit :</strong>
                                                        <p className="mb-0 f-w-500">{el.requiredProduct}</p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Completed Unit:</strong>
                                                        <p className="mb-0 f-w-500">{el.completedProduct}</p>
                                                    </div>

                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default TargetWise;